import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { Error } from '@/shared/components/Error/Error';
import { RouteSkeleton } from '@/shared/components/PageSpinner/PageSpinner';

import { personRoute } from './routes';
import { PersonNotFoundError } from './lib/errors';

const scenario = createScenario((ctx) => {
    ctx.addRoute({
        route: personRoute,
        meta: {
            plusPaymentPage: 'PersonPage',
            page: 'person',
        },
        component: lazy(() => import('./components/Person/Person')),
        fallback: RouteSkeleton,
    });

    ctx.addError({
        is: (error) => error instanceof PersonNotFoundError,
        component: Error,
    });
});

export * from './routes';

export default scenario;
